import { render, staticRenderFns } from "./TechTab.vue?vue&type=template&id=e51b8e5a&"
import script from "./TechTab.vue?vue&type=script&lang=js&"
export * from "./TechTab.vue?vue&type=script&lang=js&"
import style0 from "./TechTab.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports